
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 36.032 36.032"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#3d9ed3"}},[_c('path',{attrs:{"data-name":"Path 7105","d":"M18.016 25.223a7.206 7.206 0 117.206-7.206 7.206 7.206 0 01-7.206 7.206zm0-12.011a4.8 4.8 0 104.8 4.8 4.8 4.8 0 00-4.8-4.802z"}}),_c('path',{attrs:{"data-name":"Path 7106","d":"M24.021 36.032H12.006a4.8 4.8 0 01-4.8-4.8v-3.067a1.2 1.2 0 01.757-1.1l4.372-1.754a1.2 1.2 0 11.877 2.234l-3.606 1.437v2.246a2.4 2.4 0 002.4 2.4h12.015a2.4 2.4 0 002.4-2.4v-2.246l-3.6-1.441a1.202 1.202 0 11.889-2.234l4.372 1.754a1.2 1.2 0 01.757 1.1v3.063a4.8 4.8 0 01-4.816 4.8z"}}),_c('path',{attrs:{"data-name":"Path 7107","d":"M9.608 12.011a6.005 6.005 0 116.005-6.005 6.005 6.005 0 01-6.005 6.005zm0-9.609a3.6 3.6 0 103.6 3.6 3.6 3.6 0 00-3.6-3.602z"}}),_c('path',{attrs:{"data-name":"Path 7108","d":"M8.408 22.089H4.8a4.8 4.8 0 01-4.8-4.8v-2.1a1.2 1.2 0 01.757-1.117l3.831-1.5a1.189 1.189 0 11.877 2.21L2.4 15.998v1.285a2.4 2.4 0 002.4 2.4h3.6a1.2 1.2 0 110 2.4z"}}),_c('path',{attrs:{"data-name":"Path 7109","d":"M26.423 12.011a6.005 6.005 0 116.005-6.005 6.005 6.005 0 01-6.005 6.005zm0-9.609a3.6 3.6 0 103.6 3.6 3.6 3.6 0 00-3.6-3.602z"}}),_c('path',{attrs:{"data-name":"Path 7110","d":"M31.224 22.088h-3.6a1.2 1.2 0 010-2.4h3.6a2.4 2.4 0 002.4-2.4v-1.29l-3.063-1.2a1.206 1.206 0 01.877-2.246l3.831 1.5a1.2 1.2 0 01.757 1.117v2.1a4.8 4.8 0 01-4.802 4.819z"}})])])
          )
        }
      }
    